/**
 * @returns {Promise<Country>} {
 *   handle: 'DE',
 *   name: 'Deutschland'
 * }
 * @property {string} handle - The country code (e.g. "DE")
 * @property {string} name - The country name (e.g. "Deutschland")
 */
const getCustomerLocation = async () => {
  const res = await fetch(
    window.Shopify.routes.root +
      "browsing_context_suggestions.json" +
      "?country[enabled]=true" +
      "&language[enabled]=true"
  ).then((r) => r.json());

  /**
   * @typedef {Object} Country
   * @property {string} handle - The country code (e.g. "DE")
   * @property {string} name - The country name (e.g. "Deutschland")
   */
  return res.detected_values.country;
};

export default getCustomerLocation;
